import React from "react";

export const VendorQuotationDetailContext = React.createContext(null);

export const useVendorQuotationDetailContext = () => {
  const context = React.useContext(VendorQuotationDetailContext);

  if (!context) throw new Error("Vendor Quotation Detail Context not provided!");

  return context;
};
